import { Auth } from 'aws-amplify';

export function initPassResetAPI(email) {
  return Auth.forgotPassword(email);
}
